"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _loadingMode = _interopRequireDefault(require("../../utils/constants/loadingMode"));

var _experimentsWrapper = _interopRequireDefault(require("@wix/photography-client-lib/dist/src/sdk/experimentsWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var ImageItem =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ImageItem, _React$Component);

  function ImageItem() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ImageItem.prototype;

  _proto.componentDidMount = function componentDidMount() {
    try {
      if (typeof this.props.actions.setItemLoaded === 'function') {
        this.props.actions.setItemLoaded();
      }
    } catch (e) {
      console.error(e);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        isThumbnail = _this$props.isThumbnail,
        alt = _this$props.alt,
        visible = _this$props.visible,
        loaded = _this$props.loaded,
        displayed = _this$props.displayed,
        styleParams = _this$props.styleParams,
        imageDimensions = _this$props.imageDimensions,
        resized_url = _this$props.resized_url,
        id = _this$props.id,
        actions = _this$props.actions,
        settings = _this$props.settings;
    var imageProps = settings && settings.imageProps && typeof settings.imageProps === 'function' ? settings.imageProps(id) : {};
    var backgroundStyle = {}; //remove this inline style if rendered padding (using css) is used

    var _ref = imageDimensions || {},
        marginLeft = _ref.marginLeft,
        marginTop = _ref.marginTop,
        restOfDimensions = _objectWithoutPropertiesLoose(_ref, ["marginLeft", "marginTop"]);

    var isSEO = !!this.props.isInSEO || _experimentsWrapper["default"] && (0, _experimentsWrapper["default"])('specs.pro-gallery.SEOBotView') === 'true';
    var imageItemClassName = ['gallery-item-content', 'image-item', 'gallery-item-visible', 'gallery-item', 'gallery-item-preloaded', styleParams.cubeImages && styleParams.cubeType === 'fit' ? 'grid-fit' : '', styleParams.imageLoadingMode === _loadingMode["default"].COLOR ? 'load-with-color' : ''].join(' ');

    var imageContainer = function imageContainer(image) {
      return _react["default"].createElement("div", {
        className: imageItemClassName,
        onTouchStart: actions.handleItemMouseDown,
        onTouchEnd: actions.handleItemMouseUp,
        key: 'image_container-' + id,
        "data-hook": 'image-item',
        style: displayed ? {} : _objectSpread({}, backgroundStyle, restOfDimensions)
      }, image);
    };

    var image = _react["default"].createElement("img", _extends({
      key: (styleParams.cubeImages && styleParams.cubeType === 'fill' ? 'cubed-' : '') + 'image',
      className: 'gallery-item-visible gallery-item gallery-item-preloaded',
      "arial-label": alt,
      alt: alt,
      src: resized_url.seoLink,
      style: restOfDimensions
    }, imageProps));

    var canvas = _react["default"].createElement("canvas", _extends({
      key: (styleParams.cubeImages && styleParams.cubeType === 'fill' ? 'cubed-' : '') + 'image',
      className: 'gallery-item-visible gallery-item gallery-item-hidden gallery-item-preloaded',
      role: "img",
      "arial-label": alt,
      "data-src": resized_url.img,
      style: restOfDimensions
    }, imageProps));

    var renderedItem = isSEO ? imageContainer(image) : imageContainer(canvas);
    return renderedItem;
  };

  return ImageItem;
}(_react["default"].Component);

exports["default"] = ImageItem;